import type { PackageRedemption, PopsPackage } from '@/types/pops'

type Address = {
  address1?: string
  address2?: string
  city?: string
  country?: string
  firstName?: string
  lastName?: string
  phone?: string
  province?: string
  zip?: string
  zip5?: string
}

export class Package {
  id: number
  status: string
  shippingAddress: Address
  sku: string
  numWeeks: number
  numRedemptionsRemaining: number
  numRedemptionsRedeemed: number
  packOrderRedemptions: PackageRedemption[]

  constructor(rawPackge: PopsPackage) {
    this.id = rawPackge.id
    this.shippingAddress = rawPackge.shipping_address
    this.sku = rawPackge.sku
    this.status = rawPackge.status
    this.numWeeks = rawPackge.num_weeks
    this.numRedemptionsRemaining = rawPackge.num_redemptions_remaining
    this.numRedemptionsRedeemed = rawPackge.num_redemptions_redeemed
    this.packOrderRedemptions = rawPackge.pack_order_redemptions
  }

  get isActive() {
    return this.status === 'active'
  }
}
